<template>
    <div class="accordion-container align-middle">
        <Accordion
            :open="true"
            :navigateStep="substep==1"
            title="4.1. Material auswählen" info="Bitte beachte, dass die Leinwand eine Rahmenbreite von 2 cm hat.">
            <div v-for="(material, idx) in materials">
                <Material :title="material.title"
                          :subtitle="material.subtitle"
                          :price="pricePlusThemeCosts(material.price)"
                          :image="material.image"
                          :active="isMaterialSelected(material)"
                          @click="selectMaterial(material)"
                ></Material>
            </div>

        </Accordion>
        <Accordion
            :open="true"
            :navigateStep="this.substep==2"
            title="4.2. Format auswählen" info="Dir stehen verschiedene Formatgrößen zur Auswahl. Die Formate sind formatgetreu links im Vorschaufenster abgebildet.">
            <div v-if="selectedMaterial">
                <!-- <SelectBox name="background-text-font" class="w-full"
                    v-model="format"
                    @change="selectFrameFormat(format)">
                    <option value="" disabled="disabled" :selected="selectedFrameSize === null">Format wählen</option>
                    <option v-for="(format, idx) in formats"
                        :key="idx"
                        :value="idx"
                        :selected="isFrameSelected(format)"
                    >
                        {{ format.width }}x{{ format.height }} cm ({{ moneyFormat(pricePlusThemeCosts(format.price)) }})
                    </option>
                </SelectBox> -->

                <label class="whitespace-nowrap w-full" v-for="(portraitFormat, idx) in formats" :key="idx">
                    <Checkbox type="radio" name="format"
                        @change="selectFrameFormat(idx)"
                        :checked="isFrameSelected(portraitFormat)">
                        {{ portraitFormat.width }}x{{ portraitFormat.height }} cm ({{ moneyFormat(pricePlusThemeCosts(portraitFormat.price)) }})
                    </Checkbox>
                </label>
            </div>
            <div class="text-notice" v-else>
                *Bitte wählen Sie zunächst ein Material aus.
            </div>
        </Accordion>
    </div>
</template>

<script>
import Format from './Format.vue';
import Material from './Material.vue';
import { mapFields } from 'vuex-map-fields';
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import Checkbox from '~/scripts/Components/Checkbox.vue';
import SelectBox from "~/scripts/Components/SelectBox.vue";
import Accordion from "~/scripts/Components/Accordion.vue";
import VariationInformation from "./VariationInformation.js";
import { moneyFormat } from "~/scripts/Pipeline/_helpers.js";

export default {
    components: {
        Format,
        Material,
        Checkbox,
        Accordion,
        SelectBox,
    },
    computed: {
        ...mapFields({
            substep: 'substep',
            selectedMaterial: 'selectedMaterial',
            digitalDownload: 'digitalDownload.use',
            selectedFrameSize: 'selectedFrameSize',
            selectedFormat: 'stageConfiguration.format'
        })
    },
    data() {
        return {
            materials: [],
            formats: []
        };
    },

    mounted() {
        this.setAvailableMaterials();
        this.setAvailableFormats();
    },

    watch: {
        selectedFormat() {
            this.setAvailableFormats();
        },
        selectedMaterial() {
            this.setAvailableFormats();
        }
    },

    methods: {
        moneyFormat(value) {
            return moneyFormat(value);
        },

        isMaterialSelected(material) {
            if(!this.selectedMaterial) return false;

            return material.title === this.selectedMaterial.title;
        },

        selectMaterial(material) {
            this.$store.commit('updateField', {
                path: 'selectedMaterial',
                value: material
            });

            this.sendDOMEvent(VariationInformation.getMaterialRadioInputName(), material.optionId);

            // auto-select format-variant if format has been set before
            this.$nextTick(() => {
                this.substep++;
                if (this.selectedFrameSize) {
                    this.formats.forEach((format, idx) => {
                        if (this.isFrameSelected(format)) {
                            this.selectFrameFormat(idx);
                        }
                    });
                }
            });
        },

        isFrameSelected(format) {
            if (!this.selectedFrameSize) {
                return false;
            }

            return format.width === this.selectedFrameSize.width
                && format.height === this.selectedFrameSize.height;
        },

        selectFrameFormat(format) {
            this.$store.commit('updateField', {
                path: 'selectedFrameSize',
                value: this.formats[format]
            });

            this.sendDOMEvent(VariationInformation.getFormatRadioInputName(), this.formats[format].optionId);

            // enable next step if format selected
            this.$root.$emit('enableNextStep');

            Pipeline.generateFinalImagePreview();
        },

        /**
         * Trigger a DOM event for other scripts to catch.
         */
        sendDOMEvent(name, value) {
            let element = document.getElementById('ayv-container');

            element.dispatchEvent(new CustomEvent("variationChanged", {
                detail: {
                    name: name,
                    value: value
                }
            }));
        },

        /**
         * Return the given price plus the extra cost for the set theme.
         */
        pricePlusThemeCosts(price) {
            if(!price) {
                price = this.$store.state.basePrice;
            }

            // add theme cost (+10€ for love, +20€ for family)
            return price + this.$store.state.theme.price;
        },

        /**
         * Read material price and options ids from DOM and update our data.
         * This will add the lowest possible price for each material.
         */
        setAvailableMaterials() {
            this.materials = VariationInformation.getMaterials();
        },

        /**
         * Set all the formats that are available
         */
        setAvailableFormats() {
            if(!this.selectedMaterial) {
                return;
            }

            // get all formats that match the given ratio
            let formats = [];
            let result = [];

            if(this.selectedFormat === 'panorama') {
                formats = [
                    ...VariationInformation.getFormats(3), // 3/1
                    ...VariationInformation.getFormats(2), // 2/1
                ];
            }
            else if(this.selectedFormat === '4-3') {
                formats = VariationInformation.getFormats(4/3);
            }
            else if(this.selectedFormat === '3-2') {
                formats = VariationInformation.getFormats(3/2);
            }

            formats.forEach((format) => {
                let name = format.name ? format.name.split('x') : format.translated.name.split('x');
                let width = name[0];
                let height = name[1];
                let price = VariationInformation.getCheapestVariationPrice([
                    format.id,
                    this.selectedMaterial.optionId
                ]);

                result.push({
                    width: width,
                    height: height,
                    price: price,
                    optionId: format.id
                });
            });

            this.formats = result;
        }
    }
};
</script>
